import { MobileLayout } from 'lib/mobileDesignSystem';
import Finance from 'pages/mobile/Finance';
import FactoringApproval from 'pages/mobile/Finance/FactoringApproval';
import FactoringOperationDetail from 'pages/mobile/Finance/FactoringOperationDetail';
import FactoringDocuments from 'pages/mobile/Finance/FactoringOperationDetail/Documents';
import EvaluationNodesPage from 'pages/mobile/Finance/FactoringOperationDetail/EvaluationNodesPage';
import FinanceTabsView from 'pages/mobile/Finance/FinanceTabsView';
import Home from 'pages/mobile/Home';
import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

const MobileRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MobileLayout />}>
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="finance" element={<Finance />}>
            <Route index element={<FinanceTabsView />} />
            <Route
              path="factoring/:id"
              element={<FactoringOperationDetail />}
            />
            <Route
              path="factoring/:id/approval"
              element={<FactoringApproval />}
            />
            <Route
              path="factoring/:id/documents"
              element={<FactoringDocuments />}
            />
            <Route
              path="factoring/:id/evaluation/:evaluationId/nodes"
              element={<EvaluationNodesPage />}
            />
          </Route>
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MobileRoutes;
